import { useEffect, VFC } from 'react';
import { IWinAuthConfig } from '../authModels';

export const WindowsAuthentificator: VFC<{
    saveRoles: (roles: string[], username: string) => void;
}> = ({ saveRoles }) => {
    useEffect(() => {
        GetRoles();
    }, []);

    const GetRoles = async () => {
        let param = `?role=${localStorage.getItem('RoleAssigned') ? localStorage.getItem('RoleAssigned') : 0}`;

        const response: IWinAuthConfig = await (await fetch(`/api/config/auth-settings/win${param}`)).json();
        saveRoles(response.roles, response.username);
    };

    return null;
};
